module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showGroup) ? _c('div', {
    staticClass: "age-filters"
  }, [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-checkbox-group', {
    class: {
      'long-group': _vm.isLong, 'short-group': !_vm.isLong
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  }, [(_vm.chunk) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.chunkedOptions[0]), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey)
    }, [_c('virtual-list', {
      attrs: {
        "size": _vm.virtualListSize,
        "remain": _vm.virtualListVisible
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1), _vm._v(" "), _c('br')], 1)
  }), 0), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, _vm._l((_vm.chunkedOptions[1]), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey),
      staticClass: "overflow-text"
    }, [_c('virtual-list', {
      attrs: {
        "size": _vm.virtualListSize,
        "remain": _vm.virtualListVisible
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1), _vm._v(" "), _c('br')], 1)
  }), 0)], 1) : _c('div', [_c('virtual-list', {
    attrs: {
      "size": _vm.virtualListSize,
      "remain": _vm.virtualListVisible
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey)
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_c('el-row', [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1)], 1)
  }), 0), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6209c7a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/FilterGroup.vue
// module id = 3306
// module chunks = 3